export default __webpack_public_path__ + "static/media/2.446ad9c3.jpg";